<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_18273_62873)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.9644 48C37.6457 40.0558 44.4985 28.0558 44.5226 12L23.7302 0L3 12C3 27.5468 9.98814 39.5468 23.9644 48ZM6.35603 13.8947L23.7326 3.83596L41.1667 13.8978C40.6584 27.1424 34.9907 37.1034 23.9953 44.0959C12.6848 36.6841 6.87208 26.7089 6.35603 13.8947ZM19.077 26.0943H20.6276V17.939H23.4174V16.609H16.2872V17.939H19.077V26.0943ZM23.904 18.9187L26.311 22.4287L23.7872 26.0943H25.513L27.2777 23.4083L29.0489 26.0943H30.7747L28.2379 22.4287L30.6514 18.9187H28.9256L27.2777 21.4295L25.6428 18.9187H23.904Z"/>
</g>
<defs>
<clipPath id="clip0_18273_62873">
<rect width="48" height="48" fill="white"/>
</clipPath>
</defs>
</svg>
